import { wplToken } from "@atlassiansox/wpl-token";
// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";
import { PropsWithChildren } from "react";

const remoteSwitcherContainerStyle = (display: boolean) =>
    css`
        display: ${display ? "block" : "none"};
        position: relative;
        right: 330px;
        top: ${wplToken("space.400")};
    `;
export const RemoteSwitcherContainer = ({
    display,
    children
}: PropsWithChildren<{
    display: boolean;
}>) => {
    return (
        <div
            css={remoteSwitcherContainerStyle(display)}
            data-testid="global-nav-container"
        >
            {children}
        </div>
    );
};
